module.exports = __webpack_public_path__ + "media/images/countryrect/zw-a5985c0f7129edfed19183c43469e7d0.svg";